/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationUser } from './ApplicationUser';
import {
    ApplicationUserFromJSON,
    ApplicationUserFromJSONTyped,
    ApplicationUserToJSON,
    ApplicationUserToJSONTyped,
} from './ApplicationUser';
import type { WorkbookItem } from './WorkbookItem';
import {
    WorkbookItemFromJSON,
    WorkbookItemFromJSONTyped,
    WorkbookItemToJSON,
    WorkbookItemToJSONTyped,
} from './WorkbookItem';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface Workbook
 */
export interface Workbook {
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Workbook
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Workbook
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Workbook
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    slug?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Workbook
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    ownerUserId?: string;
    /**
     * 
     * @type {ApplicationUser}
     * @memberof Workbook
     */
    ownerUser?: ApplicationUser;
    /**
     * 
     * @type {boolean}
     * @memberof Workbook
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Workbook
     */
    requireLogin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    passwordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Workbook
     */
    passwordHint?: string | null;
    /**
     * 
     * @type {Array<WorkbookItem>}
     * @memberof Workbook
     */
    items?: Array<WorkbookItem> | null;
}

/**
 * Check if a given object implements the Workbook interface.
 */
export function instanceOfWorkbook(value: object): value is Workbook {
    return true;
}

export function WorkbookFromJSON(json: any): Workbook {
    return WorkbookFromJSONTyped(json, false);
}

export function WorkbookFromJSONTyped(json: any, ignoreDiscriminator: boolean): Workbook {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'ownerUserId': json['ownerUserId'] == null ? undefined : json['ownerUserId'],
        'ownerUser': json['ownerUser'] == null ? undefined : ApplicationUserFromJSON(json['ownerUser']),
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'requireLogin': json['requireLogin'] == null ? undefined : json['requireLogin'],
        'passwordHash': json['passwordHash'] == null ? undefined : json['passwordHash'],
        'passwordHint': json['passwordHint'] == null ? undefined : json['passwordHint'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(WorkbookItemFromJSON)),
    };
}

export function WorkbookToJSON(json: any): Workbook {
    return WorkbookToJSONTyped(json, false);
}

export function WorkbookToJSONTyped(value?: Workbook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'title': value['title'],
        'description': value['description'],
        'slug': value['slug'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'ownerUserId': value['ownerUserId'],
        'ownerUser': ApplicationUserToJSON(value['ownerUser']),
        'isPublic': value['isPublic'],
        'requireLogin': value['requireLogin'],
        'passwordHash': value['passwordHash'],
        'passwordHint': value['passwordHint'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(WorkbookItemToJSON)),
    };
}

